<template>
	<div>
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<!--<el-form-item label="小程序" prop="appid" v-if="!isAgent">-->
						<!--<app-list @getAppId="getAppId" :appId="formInline.appId"></app-list>-->
					<!--</el-form-item>-->
					<el-form-item label="用户ID" prop="id">
						<el-select v-model="userType" @change="changeUserType" style="width: 100px;">
							<el-option
									v-for="item in userTypeOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
						<el-input v-if="userType == 1" v-model="formInline.id" placeholder="请输入用户ID" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
						<el-input v-if="userType == 2" v-model="formInline.nickname" placeholder="请输入用户昵称" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
						<el-input v-if="userType == 3" v-model="formInline.username" placeholder="请输入用户名" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="投放链接ID" prop="tfid">
						<el-input v-model="formInline.tfid" placeholder="请输入投放链接ID" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="订阅类型" prop="paySigningType" style="margin-right: 30px;">
						<el-select v-model="formInline.paySigningType" placeholder="请选择订阅类型" clearable @change="search" style="width: 180px;">
							<el-option
									v-for="item in signTypeOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订阅状态" prop="signingStatus" style="margin-right: 30px;">
						<el-select v-model="formInline.signingStatus" placeholder="请选择订阅类型" clearable @change="search" style="width: 180px;">
							<el-option
									v-for="item in signStatusOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="累计订阅次数" prop="rechargeNum">
						<el-input type="number" v-model="formInline.rechargeNum" placeholder="请输入累计订阅次数" clearable @keyup.enter.native="search" @clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<!--<el-form-item label="系统类型" prop="mos" style="margin-right: 30px;">-->
						<!--<el-select v-model="formInline.mos" placeholder="请选择系统类型" clearable @change="search" style="width: 180px;">-->
							<!--<el-option-->
									<!--v-for="item in mosOptions"-->
									<!--:key="item.value"-->
									<!--:label="item.label"-->
									<!--:value="item.value"-->
							<!--&gt;</el-option>-->
						<!--</el-select>-->
					<!--</el-form-item>-->
					<br/>
					<el-form-item label="时间：" v-for="(item, index) in dataTimeList" :key="index">
						<el-select v-model="item.type" @change="changeTimeType" style="width: 130px; position: relative; top: -1px;">
							<el-option
									v-for="item in timeTypeOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
						<el-date-picker v-if="item.type == 1"
								v-model="item.dataTime"
								class="pickerData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								type="daterange"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期" style="margin-right: 10px; width: 300px" clearable @change="search">
						</el-date-picker>
						<el-date-picker v-if="item.type == 2"
								v-model="item.dataTime"
								class="pickerData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								type="daterange"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期" style="margin-right: 10px; width: 300px" clearable @change="search">
						</el-date-picker>
						<el-date-picker v-if="item.type == 3"
								v-model="item.dataTime"
								class="pickerData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								type="daterange"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期" style="margin-right: 10px; width: 300px" clearable @change="search">
						</el-date-picker>
						<el-date-picker v-if="item.type == 4"
								v-model="item.dataTime"
								class="pickerData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								type="daterange"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期" style="margin-right: 10px; width: 300px" clearable @change="search">
						</el-date-picker>
						<el-date-picker v-if="item.type == 5"
								v-model="item.dataTime"
								class="pickerData"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								type="daterange"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期" style="margin-right: 10px; width: 300px" clearable @change="search">
						</el-date-picker>
					</el-form-item>
					<i v-if="dataTimeList.length < 5" class="el-icon-circle-plus-outline" @click="addTimeType" style="line-height: 32px; margin: 0 50px 0 -10px; cursor: pointer"></i>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="success" icon="el-icon-download" @click="exportex">导出</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loading">
					<el-table-column prop="" label="序号" width="50">
						<template slot-scope="scope">
							<span>{{(tableData.pageNo - 1)* tableData.pageSize + scope.$index + 1}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="用户信息" width="195">
						<template slot-scope="scope">
							<div class="td-info">
								<p>用户ID：{{scope.row.id}}</p>
								<p>昵称：{{scope.row.nickname}}</p>
								<p>用户名：{{scope.row.username}}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="订阅类型" width="80">
						<template slot-scope="scope">
							<div>
								<p v-if="scope.row.sinaPaySigningType == 0">未签约</p>
								<p v-if="scope.row.sinaPaySigningType == 1">连续包月</p>
								<p v-if="scope.row.sinaPaySigningType == 2">连续包季</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="money" label="累计交易金额" width="65">
					</el-table-column>
					<el-table-column prop="addtime" label="首次订阅时间" width="152">
					</el-table-column>
					<el-table-column prop="latestSubscriptionTime" label="最近订阅时间" width="152">
					</el-table-column>
					<el-table-column prop="endtime" label="订阅到期时间" width="155">
					</el-table-column>
					<el-table-column label="订阅状态" width="65">
						<template slot-scope="scope">
							<div>
								<p v-if="scope.row.signingStatus == 0" class="danger-text">已取消</p>
								<p v-if="scope.row.signingStatus == 1" class="succes-text">订阅中</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="unsubscribeTime" label="最后取消订阅时间" width="152">
					</el-table-column>
					<el-table-column label="最后一次代扣" width="260">
						<template slot-scope="scope">
							<div class="td-info">
								<p>最后一次代扣金额：{{scope.row.latestWithholdingMoney }}</p>
								<p>最后一次(签约)代扣次数：{{scope.row.latestWithholdingNum }}</p>
								<p>最后一次代扣时间：{{scope.row.latestWithholdingTime }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="rechargeNum" label="累计订阅次数" width="65">
					</el-table-column>
					<el-table-column prop="clientname" label="充值客户端">
					</el-table-column>
					<!--<el-table-column prop="os" label="设备">-->
					<!--</el-table-column>-->
					<!--<el-table-column prop="title" label="充值方式">-->
					<!--</el-table-column>-->
					<el-table-column prop="registrationTime" label="注册时间" width="152">
					</el-table-column>
					<el-table-column prop="tfid" label="投放链接ID">
					</el-table-column>
					<el-table-column label="操作" width="100">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini" @click="handleLook(scope.row)">详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="total-box">
					<span>总充值：{{totalAmount}} &nbsp;&nbsp;&nbsp;&nbsp;</span>
					<span>充值人数：{{users}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
				</div>
				<div class="foot-table" style="text-align:center;">
					<!--<el-pagination @current-change="handleCurrentChange" :page-size="tableData.pageSize"-->
					<!--background :current-page="currentPage" :total="tableData.totalNum">-->
					<!--</el-pagination>-->
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[20, 50, 100, 200, 500]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
				<tr>
					<td width="200">用户信息</td>
					<td>
						<p>用户ID：{{rowFrom.id}}</p>
						<p>昵称：{{rowFrom.nickname}}</p>
						<p>用户名：{{rowFrom.username}}</p>
					</td>
				</tr>
				<tr>
					<td>订阅类型</td>
					<td>
						<p v-if="rowFrom.sinaPaySigningType == 0">未签约</p>
						<p v-if="rowFrom.sinaPaySigningType == 1">连续包月</p>
						<p v-if="rowFrom.sinaPaySigningType == 2">连续包季</p>
					</td>
				</tr>
				<tr>
					<td>累计交易金额</td>
					<td>
						<p>{{rowFrom.money}}</p>
					</td>
				</tr>
				<tr>
					<td>首次订阅时间</td>
					<td>
						<p>{{rowFrom.addtime}}</p>
					</td>
				</tr>
				<tr>
					<td>最近订阅时间</td>
					<td>
						<p>{{rowFrom.latestSubscriptionTime}}</p>
					</td>
				</tr>
				<tr>
					<td>订阅到期时间</td>
					<td>
						<p>{{rowFrom.endtime}}</p>
					</td>
				</tr>
				<tr>
					<td>订阅状态</td>
					<td>
						<p v-if="rowFrom.signingStatus == 0" class="danger-text">已取消</p>
						<p v-if="rowFrom.signingStatus == 1" class="succes-text">订阅中</p>
					</td>
				</tr>
				<tr>
					<td>最后取消订阅时间</td>
					<td>
						<p>{{rowFrom.unsubscribeTime}}</p>
					</td>
				</tr>
				<tr>
					<td>最后一次代扣</td>
					<td>
						<div class="td-info">
							<p>最后一次代扣金额：{{rowFrom.latestWithholdingMoney }}</p>
							<p>最后一次(签约)代扣次数：{{rowFrom.latestWithholdingNum }}</p>
							<p>最后一次代扣时间：{{rowFrom.latestWithholdingTime }}</p>
						</div>
					</td>
				</tr>
				<tr>
					<td>累计订阅次数</td>
					<td>
						<p>{{rowFrom.rechargeNum}}</p>
					</td>
				</tr>
				<tr>
					<td>充值客户端</td>
					<td>
						<p>{{rowFrom.clientname}}</p>
					</td>
				</tr>
				<tr>
					<td>注册时间</td>
					<td>
						<p>{{rowFrom.registrationTime}}</p>
					</td>
				</tr>
				<tr>
					<td>投放链接ID</td>
					<td>
						<p>{{rowFrom.tfid}}</p>
					</td>
				</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
    // import AppList from '@/components/AppList'
    import { listUser } from "@/api/wb/user/subscribe";
    export default {
        // components: {
        //     AppList
        // },
        data() {
            // var validateNum = (rule, value, callback) => {
            //     if (!(/(^[1-9]\d*$)/.test(value))) {
            //         return callback(new Error('数字应为正整数'));
            //     } else {
            //         callback();
            //     }
            // };
            return {
                loading: false,
				platform: localStorage.getItem('platform'),
                dataTimeList: [
                    {
                        type: 1,
                        dataTime: [this.getCurrentDate(new Date(new Date().getTime() - 29 * 24 * 60 * 60 * 1000)), this.getCurrentDate(new Date())]
                    },
				],
				userType: 1,
                userTypeOptions: [
					{
                        label: '用户ID',
                        value: 1
                    },
                    {
                        label: '用户昵称',
                        value: 2
                    },
                    {
                        label: '用户名',
                        value: 3
                    }
				],
                timeTypeOptions: [
                    {
                        label: '注册时间',
                        value: 1
                    },
                    {
                        label: '首次订阅时间',
                        value: 2
                    },
                    {
                        label: '最近订阅时间',
                        value: 3
                    },
                    {
                        label: '订阅到期时间',
                        value: 4
                    },
                    {
                        label: '取消订阅时间',
                        value: 5
                    }
                ],
                formInline: {
                    id: '',
                    nickname: '',
                    username: '',
                    tfid: '',
                    paySigningType: '',
                    signingStatus: '',
                    rechargeNum: '',
                    registrationBeginTime: '',
                    registrationEndTime: '',
                    beginTime: '',
                    endTime: '',
                    lsBeginTime: '',
                    lsEndTime: '',
                    expirationBeginTime: '',
                    expirationEndTime: '',
                    unsubscribeBeginTime: '',
                    unsubscribeEndTime: ''
                },
                tableData: {
                    pageSize: 20,
                    pageNo: 1,
                    totalPage: 1,
                    totalNum: 0,
                    result: [
                    ]
                },
                currentPage: 1,
                totalAmount: 0,
				users: 0,
                dialogFormVisible: false,
                signTypeOptions: [
                    {
                        label: '全部',
                        value: ''
                    },
                    {
                        label: '未签约',
                        value: 0
                    },
                    {
                        label: '连续包月',
                        value: 1
                    },
                    {
                        label: '连续包季',
                        value: 2
                    }
                ],
                signStatusOptions: [
                    {
                        label: '全部',
                        value: ''
                    },
                    {
                        label: '已取消',
                        value: 0
                    },
                    {
                        label: '订阅中',
                        value: 1
                    }
                ],
                mosOptions: [{
                    value: 'iOS',
                    label: 'iOS'
                }, {
                    value: 'android',
                    label: 'android'
                }],
                durationTypeOptions: [ // 类型
                    {
                        value: 0,
                        label: '充值金币'
                    },
                    {
                        value: 1,
                        label: '月度会员'
                    },
                    {
                        value: 4,
                        label: '季度会员'
                    },
                    {
                        value: 2,
                        label: '年度会员'
                    },
                    {
                        value: -1,
                        label: '单剧购买(代理商专属)'
                    },
                ],
                rowFrom: {},
                dialogInfoVisible: false,
				isAgent:false
            }
        },
        computed: {},
        watch: {
        },
        mounted: function() {
			if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId){
				this.isAgent = true
				this.formInline.appId = JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
			}
            this.getTableData()
        },
        methods: {
            addTimeType () {
				this.dataTimeList.push(
                    {
                        type: 1,
                        dataTime: []
                    }
				)
			},
            // 从组件获取appid
            // getAppId(data) {
            //     this.formInline.appId = data
            //     this.getTableData()
            // },
            getCurrentDate (now) {
                // let now = new Date();
                let year = now.getFullYear();
                let month = now.getMonth() + 1;
                let day = now.getDate();
                return year + '-' + month + '-' + day;
            },
            search() {
                this.currentPage = 1
                this.getTableData()
            },
            resetQuery: function(){
                this.$refs['formInline'].resetFields()
				this.dataTime = []
                this.getTableData()
            },
            changeUserType () {
                this.formInline.id = ''
				this.formInline.username = ''
				this.formInline.nickname = ''
                this.search()
			},
            changeTimeType () {
                this.search()
			},
            // pageSize切换
            handleSizeChange (val) {
                this.tableData.pageSize  = val
                this.currentPage = 1
                this.getTableData()
            },
            handleCurrentChange(value) {
                this.currentPage = value
                this.getTableData()
            },
            handleLook(row) {
				this.rowFrom = row
                this.dialogInfoVisible = true
                
            },
            getTableData() {
                let json2 = {
                    pageNo: this.currentPage,
                    pageSize: this.tableData.pageSize
                };
                this.formInline.registrationBeginTime = ''
                this.formInline.registrationEndTime = ''
                this.formInline.beginTime = ''
                this.formInline.endTime = ''
                this.formInline.lsBeginTime = ''
                this.formInline.lsEndTime = ''
                this.formInline.expirationBeginTime = ''
                this.formInline.expirationEndTime = ''
                this.formInline.unsubscribeBeginTime = ''
                this.formInline.unsubscribeEndTime = ''
                console.log(this.dataTimeList)
                this.dataTimeList.forEach((item) => {
                    if (item.type === 1) {
                        console.log(item)
                        this.formInline.registrationBeginTime = item.dataTime ? item.dataTime[0] : ''
                        this.formInline.registrationEndTime = item.dataTime ? item.dataTime[1] : ''
					} else if (item.type === 2) {
                        this.formInline.beginTime = item.dataTime ? item.dataTime[0] : ''
                        this.formInline.endTime = item.dataTime ? item.dataTime[1] : ''
					} else if (item.type === 3) {
                        this.formInline.lsBeginTime = item.dataTime ? item.dataTime[0] : ''
                        this.formInline.lsEndTime = item.dataTime ? item.dataTime[1] : ''
                    } else if (item.type === 4) {
                        this.formInline.expirationBeginTime = item.dataTime ? item.dataTime[0] : ''
                        this.formInline.expirationEndTime = item.dataTime ? item.dataTime[1] : ''
                    } else if (item.type === 5) {
                        this.formInline.unsubscribeBeginTime = item.dataTime ? item.dataTime[0] : ''
                        this.formInline.unsubscribeEndTime = item.dataTime ? item.dataTime[1] : ''
                    }
				})
                // this.formInline.registerStartDate = this.dataTime ? this.dataTime[0] : ''
                // this.formInline.registerEndDate = this.dataTime ? this.dataTime[1] : ''
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2 };
                listUser(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
                        this.tableData = response.data.content.page
                        this.totalAmount = response.data.content.sumData.money,
                        this.users = response.data.content.sumData.userCount
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            },
            //导出
            exportex() {
                console.log("导出")
                this.formInline.registrationBeginTime = ''
                this.formInline.registrationEndTime = ''
                this.formInline.beginTime = ''
                this.formInline.endTime = ''
                this.formInline.lsBeginTime = ''
                this.formInline.lsEndTime = ''
                this.formInline.expirationBeginTime = ''
                this.formInline.expirationEndTime = ''
                this.formInline.unsubscribeBeginTime = ''
                this.formInline.unsubscribeEndTime = ''
                this.dataTimeList.forEach((item) => {
                    if (item.type === 1) {
                        this.formInline.registrationBeginTime = item.dataTime.length > 0 ? item.dataTime[0] : ''
                        this.formInline.registrationEndTime = item.dataTime.length > 0 ? item.dataTime[1] : ''
                    } else if (item.type === 2) {
                        this.formInline.beginTime = item.dataTime.length > 0 ? item.dataTime[0] : ''
                        this.formInline.endTime = item.dataTime.length > 0 ? item.dataTime[1] : ''
                    } else if (item.type === 3) {
                        this.formInline.lsBeginTime = item.dataTime.length > 0 ? item.dataTime[0] : ''
                        this.formInline.lsEndTime = item.dataTime.length > 0 ? item.dataTime[1] : ''
                    } else if (item.type === 4) {
                        this.formInline.expirationBeginTime = item.dataTime.length > 0 ? item.dataTime[0] : ''
                        this.formInline.expirationEndTime = item.dataTime.length > 0 ? item.dataTime[1] : ''
                    } else if (item.type === 5) {
                        this.formInline.unsubscribeBeginTime = item.dataTime.length > 0 ? item.dataTime[0] : ''
                        this.formInline.unsubscribeEndTime = item.dataTime.length > 0 ? item.dataTime[1] : ''
                    }
                })
				console.log(this.formInline.registrationBeginTime, this.formInline.beginTime)
                if (this.tableData.result.length >= 0) {
                    let url = '/short/userSigningStatus/getSubscribers/exportExcel?appId=' + localStorage.getItem('appId') + '&Platform=' + localStorage.getItem('platform') + '&id=' + this.formInline.id + '&nickname=' + this.formInline.nickname + '&username=' + this.formInline.username + '&tfid=' + this.formInline.tfid + '&paySigningType=' + this.formInline.paySigningType + '&signingStatus=' + this.formInline.signingStatus + '&rechargeNum=' + this.formInline.rechargeNum + 
                        '&registrationBeginTime=' + this.formInline.registrationBeginTime + '&registrationEndTime=' + this.formInline.registrationEndTime + '&beginTime=' + this.formInline.beginTime + '&endTime=' + this.formInline.endTime + '&lsBeginTime=' + this.formInline.lsBeginTime + '&lsEndTime=' + this.formInline.lsEndTime +
                        '&expirationBeginTime=' + this.formInline.expirationBeginTime + '&expirationEndTime=' + this.formInline.expirationEndTime + '&unsubscribeBeginTime=' + this.formInline.unsubscribeBeginTime + '&unsubscribeEndTime=' + this.formInline.unsubscribeEndTime
					console.log(url)
                    window.open(url)
                } else {
                    this.$message.error('没有数据');
                }
            },
        }
    }
</script>
